import React, { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import fetch from 'isomorphic-unfetch'

// Components
import { Seo, Footer } from '../../components'

// Styled Components
import { PageWrapper, ContentWrapper } from '../../styles/layout'

import pgContent from './content.md'

const SupportUs = () => {
  const [content, setContent] = useState(null)

  const fetchContent = async () => {
    const response = await fetch(pgContent)
    const text = await response.text()
    setContent(text)
  }

  useEffect(() => {
    fetchContent()
  }, [])

  return (
    <PageWrapper>
      <Seo
        title="Support Us"
        description="SVG Artista is free to use, but if you like it please consider donating a small amount as a token of appreciation. All donations are accepted and appreciated."
        slug="support-us"
        keywords={['support', 'donate', 'sponsor', 'sponsorship', 'advertising']}
      />

      {/* Main Content */}
      <ContentWrapper
        className="page-content"
        as={ReactMarkdown}
        source={content}
        escapeHtml={false}
        linkTarget={url => url.match(/https?:\/\//) && '_blank'}
        // linkTarget={(url, text, title) => url.match(/https?:\/\//) && '_blank'}
      />

      {/* Footer */}
      <Footer />
    </PageWrapper>
  )
}

export default SupportUs
